import api from 'api';

export const MENU_ITEM_STANDARD_COST_ASYNC_ACTION_START = 'MENU_ITEM_STANDARD_COST_ASYNC_ACTION_START';
export const MENU_ITEM_STANDARD_COST_ASYNC_ACTION_ERROR = 'MENU_ITEM_STANDARD_COST_ASYNC_ACTION_ERROR';
export const MENU_ITEM_STANDARD_COST_ASYNC_ACTION_UPDATE_SUCCESS = 'MENU_ITEM_STANDARD_COST_ASYNC_ACTION_UPDATE_SUCCESS';
export const MENU_ITEM_STANDARD_COST_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_STANDARD_COST_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_STANDARD_COST_RESET_STATE = 'MENU_ITEM_STANDARD_COST_RESET_STATE';

function menuItemStandardCostAsyncActionStart() {
  return {
    type: MENU_ITEM_STANDARD_COST_ASYNC_ACTION_START,
  };
}

function menuItemStandardCostAsyncActionError(error) {
  return {
    type: MENU_ITEM_STANDARD_COST_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemStandardCostAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_STANDARD_COST_ASYNC_ACTION_UPDATE_SUCCESS,
    data,
  };
}

export function resetMenuItemStandardCostState() {
  return {
    type: MENU_ITEM_STANDARD_COST_RESET_STATE,
  };
}

export function updateMenuItemStandardCost(data) {
  return {
    type: MENU_ITEM_STANDARD_COST_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function standardCostBasedLookup(menuItemCategoryId) {
  return (dispatch, getState) => {
    dispatch(menuItemStandardCostAsyncActionStart());
    return api.request(
      `menuItemCost/standardBasedCostLookup?menuItemCategoryId=${ menuItemCategoryId }`,
      'get',
      null
    )
    .then((data) => {
      dispatch(menuItemStandardCostAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemStandardCostAsyncActionError('Unable to lookup cost'));
      throw (err);
    });
  };
}
